import { handleFloatingPromise } from "@solvari/utils";

import { initExpertSite } from "./expertSite";

import "./components/accordion.js";
import "./components/sidebarCta.js";

import "../styles/evotis_5.css";

handleFloatingPromise(initExpertSite());
